import React from "react";

import styles from "../assets/styles/HomePortal.module.scss";

import PortalButton from "./PortalButton";

const HomePortal = ({ ownPortals, recommendedPortals }) => {
	const library = ownPortals.map((item, i) => {
		let className = styles.gridItem;
		let type = "small";
		if (i === 0) {
			type = "large";
			className += ` ${styles.large}`;
		}
		return (
			<div className={className}>
				<PortalButton
					headline={item.headline}
					image={item.image}
					to={item.to}
					type={type}
				/>
			</div>
		);
	});

	const recommended = recommendedPortals.map(item => {
		return (
			<div className={styles.gridItem}>
				<PortalButton
					headline={item.headline}
					image={item.image}
					price={item.price}
					description={item.description}
					type="disabled"
				/>
			</div>
		);
	});

	const primary = styles.grid + ` ${styles.primary}`;
	const secondary = styles.grid + ` ${styles.secondary}`;

	return (
		<div className={styles.root}>
			<div className={styles.container}>
				<div className={styles.headline}>Library</div>
				<div className={primary}>{library}</div>
				<div className={styles.headline}>Top picks for you</div>
				<div className={secondary}>{recommended}</div>
			</div>
		</div>
	);
};

export default HomePortal;
